<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :auto-fetch="false" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :row-height="60" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <BjFormItemCode v-model="channelData.code" disabled :label="$t('ChannelManagement.Main.code')" @keyup.enter.native="handleQuery" />
          </el-col>
          <el-col :span="colSpan">
            <BjFormItemCode v-model="channelData.name" disabled :label="$t('ChannelManagement.Main.name')" @keyup.enter.native="handleQuery" />
          </el-col>
          <el-col :span="colSpan">
            <BjFormItemCode v-model="queryParams.skuCode" :label="$t('BusinessPurchaseSupplierShop.header.skuCode')" prop="skuCode" @keyup.enter.native="handleQuery" />
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('table.createTimeText')">
              <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('table.createTimeText')"/>
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
            <el-button type="primary" @click="onImport">{{ $t('BusinessPurchaseSupplierShop.export.excelImport') }}</el-button>
            <el-button type="primary" @click="onExport">{{ $t('BusinessPurchaseSupplierShop.export.export') }}</el-button>
            <el-button type="primary" :disabled="!selectedRows.length" @click="onDeleteSelected()">{{ $t('delText') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="{ row }">
                <template v-if="false" />
                <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template v-slot="{ row }">
              <el-button type="text" class="edit-btn" @click="onEdit(row)">{{ $t('editText') }}</el-button>
              <el-button type="text" class="delete-btn" @click="onDeleteSelected(row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 新增/编辑弹窗 -->
      <DataForm ref="DataForm" @reFresh="reFresh" />
      <!-- EXCEL导入 -->
      <ExcelImportDialog ref="ExcelImport" @submit="getExcelData" @reFresh="$refs.BjPage.onSearch()" />
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { thirdApi } from '@/api';
  import { STATUS_YES_TRUE } from '@/utils/constants';
  import DataForm from './components/DataForm.vue';
  import ExcelImportDialog from './components/ExcelImportDialog';
  import moment from 'moment/moment';
  import papa from 'papaparse';
  export default {
    name: 'BusinessChannelOnlinePriceManagement',
    components: { DataForm, ExcelImportDialog },
    mixins: [pageMiXin],
    data() {
      return {
        STATUS_YES_TRUE,
        queryApi: thirdApi.getThirdPartyGoods,
        // 查询参数
        queryParamsTime: null,
        queryParams: {
          createTimeBegin: null,
          createTimeEnd: null,
          channelCode: null,
          storeId: null
        },
        labelList: [
          { label: this.$t('ChannelManagement.Main.code'), prop: 'storeCode', isCheck: true, disabled: false, width: 170 },
          { label: this.$t('ChannelManagement.Main.name'), prop: 'storeName', isCheck: true, disabled: false, width: 170 },
          { label: this.$t('BusinessPurchaseSupplierShop.table.sku'), prop: 'innerSkuCode', isCheck: true, disabled: false, width: 170 },
          { label: this.$t('ChannelManagement.Main.innerSkuCode'), prop: 'skuCode', isCheck: true, disabled: false, width: 170 },
          { label: this.$t('ChannelManagement.Main.oldPrice'), prop: 'oldPrice', isCheck: true, disabled: false, width: 120 },
          { label: this.$t('ChannelManagement.Main.price'), prop: 'price', isCheck: true, disabled: false, width: 120 },
          { label: this.$t('ChannelManagement.Main.newPrice'), prop: 'newPrice', isCheck: true, disabled: false, width: 120 },
          { label: this.$t('ChannelManagement.Main.updatePriceTime'), prop: 'updatePriceTime', isCheck: true, disabled: false, width: 200 },
          { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false, width: 200},
          { label: this.$t('table.createdByText'), prop: 'createdName', isCheck: true, disabled: false, width: 130},
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 135 },
        ],
        channelData: null
      };
    },
    computed: {},
    watch: {
      queryParamsTime(v) {
        this.queryParams.innerCreatedAtStart = (v || [])[0];
        this.queryParams.innerCreatedAtEnd = (v || [])[1];
      },
    },
    created() {
      this.channelData = this.$store.getters.storePriceControl;
      this.queryParams.channelCode = this.$store.getters.storePriceControl.channelTypeCode;
      this.queryParams.storeId = this.$store.getters.storePriceControl.id;
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.BjPage.onSearch();
      });
    },
    methods: {
      getExcelData(data) { },
      beforeResetSearch() {
        this.queryParamsTime = null;
        return new Promise(resolve => {
          resolve();
        });
      },
      /** 新增 */
      onAdd() {
        this.$refs.DataForm.show();
      },
      /** 编辑操作 */
      onEdit(row) {
        this.$refs.DataForm.show(this.$lodash.clone(row));
      },
      /** 删除操作 */
      onDeleteSelected(row) {
        let idList = [];
        if (row) {
          idList = [row.id];
        } else {
          this.selectedRows.forEach(row => idList.push(row.id));
        }
        this.$MessageBox({ content: this.$t('toast.deletionConfirmationText') }).then(() => {
          this.batchDeleteApi({ idList });
        });
      },
      /** 导入 */
      onImport() {
        this.$refs.ExcelImport.show();
      },
      /** 导出 */
      onExport() {
        const fileName = 'storeSkuPriceImport';
        if (!this.selectedRows.length) {
          this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
          return;
        }
        const csvData = [];
        this.selectedRows.forEach(item => {
          csvData.push({
            'SKU': item.innerSkuCode,
            'platform SKU': item.skuCode,
            'price(active now)': item.price,
            'price(active future with active time)': item.newPrice,
            'active time(dd/mm/yyyy)': item.updatePriceTime ? moment(item.updatePriceTime).format('DD/MM/YYYY') : '',
          });
        });
        if (!csvData.length) return;
        const csv = papa.unparse(csvData);
        const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const csvURL = window.URL.createObjectURL(data);
        const download = document.createElement('a');
        document.body.appendChild(download);
        download.href = csvURL;
        download.setAttribute('download', fileName);
        download.click();
        document.body.removeChild(download);
        this.$refs.BjPage.onResetQuery();
      },
      batchDeleteApi(ids) {
        thirdApi.deleteThirdPartyGoods(ids).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      },
    },
  };
  </script>
